import { ActionTree } from 'vuex'
import { Events } from './types'
import { RootState } from '../types'
import { AgentsHelpers } from '@/helpers/mainExports.js'

export const actions: ActionTree<Events, RootState> = {
  async fillAgents({ commit }) {
    const { response } = await AgentsHelpers.getAgents()

    const agents = response.args[0]

    commit('setAgents', { agents })
    commit('resetFilterAgentsState')
  },
  filterAgentsByString({ state, dispatch, commit }, { string }) {
    if (string.length > 1) {
      const filterAgents = state.agents.filter(
        agent =>
          agent.label.toLowerCase().match(string) ||
          ('things' in agent
            ? Object.values(agent.things ?? {}).some(thing =>
                thing.toLowerCase().match(string)
              )
            : false)
      )
      commit('setFilterAgentsByString', { filterAgents })
    } else commit('resetFilterAgentsState')
  }
}
